export default {
  checklistTransactions: [],
  checklistTransaction: undefined,
};
